import type { Address } from '@einwert/valuation-api-client'
import { joinDefinedStrings } from 'ComponentLibrary'
import dayjs from 'dayjs'

type AddressSlugInput = Pick<Address, 'street' | 'house_number' | 'city'>

export const getAssetAddressSlug = (address: AddressSlugInput): string =>
    joinDefinedStrings([address.street, address.house_number, address.city], '_').replace(/\s+/g, '_')

export const getValXmlFileName = ({ valuationDate, address }: { valuationDate?: string; address: AddressSlugInput }): string => {
    const valuationDateNewFormat = valuationDate ? dayjs(valuationDate).format('YYYY_MM_DD') : undefined
    const prefix = joinDefinedStrings([valuationDateNewFormat, 'ValXML'], '_') || 'ValXML'
    return `${prefix}_${getAssetAddressSlug(address)}.xml`
}
